import React from "react";
import { CustomizedAlert } from "./CustomizedAlert";

export const LaunchError = () => {
  const notifyAdminSuffix =
    " Please try again. Notify an administrator if you continue to recieve this message.";
  let errorKeyMappings = {
    "invalid-lti-request": "Invalid LTI launch request." + notifyAdminSuffix,
    "unhandled-instruction-launch":
      "An error occurred launching the instructions." + notifyAdminSuffix,
    "unhandled-selector-launch":
      "An error occurred launching the selector." + notifyAdminSuffix,
    "unhandled-legacy-instruction-launch":
      "An error occurred launching the legacy instructions." +
      notifyAdminSuffix,
  };

  // Default error message
  let errorMessage =
    "An error occurred launching the application." + notifyAdminSuffix;

  // Get the error key from the URL.
  let url = new URL(window.location.href);
  let errorKey = url.searchParams.get("key");
  if (errorKey !== null && errorKey !== "") {
    if (errorKeyMappings[errorKey] != null) {
      errorMessage = errorKeyMappings[errorKey];
    }
  }

  return <CustomizedAlert status="error" text={errorMessage} />;
};
